import { getPathPrefix } from "utils/getPathPrefix";
import type { TemplateSelectionCardProps } from "./utils";
import styles from "./template-selection.module.css";

export default function TemplateSelectionCard({
  template,
  handleTemplateClick,
  handleTemplateHover,
}: {
  template: TemplateSelectionCardProps;
  handleTemplateClick: (templateId: string) => void;
  handleTemplateHover: (templateId: string | null) => void;
}) {
  return (
    <div
      className={styles.templateCard}
      onClick={() => handleTemplateClick(template.id)}
      onMouseEnter={() => handleTemplateHover(template.id)}
      onMouseLeave={() => handleTemplateHover(null)}
    >
      <div
        className={styles.iconContainer}
        style={{
          backgroundImage: `url(${getPathPrefix("/images/onboarding/cim/choose_template/background.png")})`,
        }}
      >
        <img src={getPathPrefix(template.icon)} alt={template.name} className={styles.icon} />
      </div>
      <span className={styles.templateName}>{template.name}</span>
      <div className={styles.templateCardBottom} />
    </div>
  );
}
